import React from 'react'
import PropTypes from 'prop-types'
import Modal from '#components/m/Modal'
import Button from '#components/a/Button'

function AusbildungsplanHeaderModal({
  id,
  confirmCallback,
  confirmText,
  trigger,
  variant,
  modifiers,
  disabled,
  children,
}) {
  return (
    <Modal
      id={id}
      modifier="ausbildungsplan__headerModal"
      trigger={
        <Button
          testid="ablehnen-button"
          disabled={disabled}
          text={trigger}
          variant={variant || 'primary'}
          modifiers={modifiers}
        />
      }
      confirmCallback={confirmCallback}
      confirmText={confirmText}
      hasCloseButton
    >
      {children}
    </Modal>
  )
}

AusbildungsplanHeaderModal.propTypes = {
  id: PropTypes.string,
  confirmCallback: PropTypes.func,
  confirmText: PropTypes.string,
  trigger: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  variant: PropTypes.oneOf(['primary', 'primarydark', 'secondary', 'secondarydark']),
  modifiers: PropTypes.arrayOf(PropTypes.string),
}

export default AusbildungsplanHeaderModal
